import { createAction } from '@reduxjs/toolkit';
import { ControlActionTypes, ControlDict } from './models';

// Use createAction helper functions since they are stictly typed out of the box

export const loadControlsStart = createAction(ControlActionTypes.LOAD_CONTROLS_START);

export const loadControlsSuccess = createAction(
  ControlActionTypes.LOAD_CONTROLS_SUCCESS,
  (controls: ControlDict) => ({
    payload: controls,
  })
);

export const loadControlsFailure = createAction(
  ControlActionTypes.LOAD_CONTROLS_FAILURE,
  // TODO: Add and implement ErrMsg Interface
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (errMsg: any) => ({
    payload: errMsg,
  })
);
